import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const AiVideoGenerator = React.lazy(() =>
    import('../AiVideoGenerator')
);
const aiVideoGeneratorRoutesRegistry = [
    {
        path: PAGE_URL.AI_VIDEO_GENERATOR_PAGE,
        element: <AiVideoGenerator />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default aiVideoGeneratorRoutesRegistry;
